// Shared helpers for forum thread/post rendering.

export function relativeTime(iso) {
  if (!iso) return '';
  const diff = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (diff < 60) return 'hace un instante';
  if (diff < 3600) return `hace ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `hace ${Math.floor(diff / 3600)} h`;
  return new Date(iso).toLocaleString();
}

export function avatarInitials(name) {
  return (name || '?').split(' ').slice(0, 2).map((n) => n[0]).join('').toUpperCase();
}

export function fullDate(iso) {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString('es-MX', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'America/Mexico_City' }); }
  catch { return ''; }
}

export function monthYear(iso) {
  if (!iso) return '';
  try { return new Date(iso).toLocaleDateString('es-MX', { month: 'short', year: 'numeric' }); }
  catch { return ''; }
}

export function escapeHtml(str) {
  return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// Build the HTML that should be stored when quoting a post. Prefers rich HTML,
// falls back to plain body, then to the first text block (or an image marker)
// so quoting a block-only post never yields an empty quote.
export function quoteHtmlFromPost(post) {
  if (post.body_html && post.body_html.trim()) return post.body_html;
  if (post.body && post.body.trim()) return `<p>${escapeHtml(post.body)}</p>`;
  const blocks = post.body_blocks;
  if (Array.isArray(blocks)) {
    const t = blocks.find((b) => b && b.type === 'text' && b.data && (b.data.html || '').trim());
    if (t) return t.data.html;
    if (blocks.some((b) => b && b.type === 'image')) return '<p><em>[imagen adjunta]</em></p>';
    if (blocks.some((b) => b && b.type === 'document')) return '<p><em>[archivo adjunto]</em></p>';
  }
  return '';
}
